import { r as registerInstance, h, H as Host, g as getElement } from './index-8f7fb048.js';
import { g as getNamespacedTagFor } from './index-739b155e.js';

const marketProgressTrackerCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:contents}:host>ol{display:flex;flex-direction:column;margin:0;padding:0;list-style:none}";

const MarketProgressTracker = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.currentStepIndex = undefined;
    this.completedSteps = undefined;
    this.size = undefined;
    this.variant = undefined;
    this.indicator = undefined;
    this.reversed = false;
    this.barless = false;
  }
  setStepProps() {
    var _a, _b;
    const { barless, completedSteps, currentStepIndex, el, indicator, size, reversed, variant } = this;
    const stepEls = [
      ...el.querySelectorAll(getNamespacedTagFor('market-progress-tracker-step')),
    ];
    if (!(stepEls === null || stepEls === void 0 ? void 0 : stepEls.length)) {
      return;
    }
    const currentIndex = (_a = currentStepIndex !== null && currentStepIndex !== void 0 ? currentStepIndex : completedSteps) !== null && _a !== void 0 ? _a : -1;
    (_b = (reversed ? [...stepEls].reverse() : stepEls)) === null || _b === void 0 ? void 0 : _b.forEach((stepEl, index) => {
      stepEl.size = size !== null && size !== void 0 ? size : stepEl.size;
      if (variant !== null && variant !== void 0 ? variant : indicator) {
        stepEl.indicator = variant !== null && variant !== void 0 ? variant : indicator;
      }
      const isCompleted = index < currentIndex;
      const isActive = index === currentIndex;
      stepEl.completed = isCompleted;
      stepEl.active = isActive;
      if (isCompleted || (isActive && reversed)) {
        stepEl.bar = 'active';
      }
      else {
        stepEl.bar = 'inactive';
      }
    });
    // remove bar if barless or last step
    stepEls.forEach((stepEl, index) => {
      if (barless || index + 1 === stepEls.length) {
        stepEl.bar = 'hidden';
      }
    });
  }
  handleDefaultSlotChange() {
    this.setStepProps();
  }
  connectedCallback() {
    this.handleDefaultSlotChange();
  }
  render() {
    return (h(Host, { class: "market-progress-tracker" }, h("ol", null, h("slot", { onSlotchange: () => this.handleDefaultSlotChange() }))));
  }
  get el() { return getElement(this); }
};
MarketProgressTracker.style = marketProgressTrackerCss;

export { MarketProgressTracker as market_progress_tracker };
